import { programRequestsApi } from '../api/programRequestsApi';
import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditSplitRequest } from './splitProgramModel';

export const editSplitProgramFlow = ({
    form,
    newPrograms,
    files,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditSplitRequest(form, newPrograms, details),
        files,
        onError,
        updateRequest: api.updateSplitRequest,
        uploadFiles: api.uploadFiles,
    });
